// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-components-QuerySearch-QuerySearch-module__search--Ae7cj {
  flex: auto;
  width: 100%;
}
.src-components-QuerySearch-QuerySearch-module__btn--FPjt0 {
  display: flex;
  align-items: center;
  gap: 6px;
  border: none;
  background-color: transparent;
  cursor: pointer;
}
.src-components-QuerySearch-QuerySearch-module__btn--FPjt0:disabled {
  cursor: not-allowed;
  opacity: 0.45;
  color: rgba(0, 0, 0, 0.45);
}
/*# sourceMappingURL=QuerySearch.module.css.map */`, "",{"version":3,"sources":["webpack://./QuerySearch.module.less","webpack://./src/components/QuerySearch/QuerySearch.module.less"],"names":[],"mappings":"AAAA;EACE,UAAA;EACA,WAAA;ACCF;ADEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,6BAAA;EACA,eAAA;ACAF;ADGA;EACE,mBAAA;EACA,aAAA;EACA,0BAAA;ACDF;AACA,iDAAiD","sourcesContent":[".search {\n  flex: auto;\n  width: 100%;\n}\n\n.btn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  border: none;\n  background-color: transparent;\n  cursor: pointer;\n}\n\n.btn:disabled {\n  cursor: not-allowed;\n  opacity: 0.45;\n  color: rgba(0, 0, 0, 0.45);\n}\n",".search {\n  flex: auto;\n  width: 100%;\n}\n.btn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  border: none;\n  background-color: transparent;\n  cursor: pointer;\n}\n.btn:disabled {\n  cursor: not-allowed;\n  opacity: 0.45;\n  color: rgba(0, 0, 0, 0.45);\n}\n/*# sourceMappingURL=QuerySearch.module.css.map */"],"sourceRoot":""}]);
// Exports
export var search = `src-components-QuerySearch-QuerySearch-module__search--Ae7cj`;
export var btn = `src-components-QuerySearch-QuerySearch-module__btn--FPjt0`;
export default ___CSS_LOADER_EXPORT___;
